import { Injectable } from '@angular/core';
import { AnalyticsImplementation, AnalyticsPageType } from './analytics.service';
import { TealiumUtagService } from './utag.service';
import { ConfigurationData } from '../config.service';
import { MemberInfo, MemberAddress, MemberPhoneNumber, MemberEmailAddress } from '../session-data';
import { SessionService } from '../session.service';

@Injectable({
  providedIn: 'root'
})
export class MarketingService implements AnalyticsImplementation {

  private configuration: any;
  private memberData: any;

  constructor(
    private tealium: TealiumUtagService,
    private sessionService: SessionService
  ) { }

  public init(config: ConfigurationData): void {
    this.configuration = config.tealium;
    this.tealium.setConfig({
      account: this.configuration.account,
      profile: this.configuration.profile,
      environment: this.configuration.environment
    });

    let sessionData = this.sessionService.getSessionData();
    let memberInfo = sessionData.memberInfo || new MemberInfo();
    let memberAddress = memberInfo.getPrimaryAddress() || new MemberAddress();
    let memberPhone = memberInfo.getPrimaryPhone() || new MemberPhoneNumber();
    let memberEmail = memberInfo.getPrimaryEmail() || new MemberEmailAddress();
    let memberClass = sessionData.identity != null ? sessionData.identity.ice_member_class_id : '';

    this.memberData = {
      customer_city: memberAddress.city,
      customer_country: memberAddress.country,
      customer_email: memberEmail.address,
      customer_expiration: memberInfo.expiration_date,
      customer_id: memberInfo.member_id,
      customer_member_class: memberClass,
      customer_phone: memberPhone.number,
      customer_postal_code: memberAddress.postal_code,
      customer_state: memberAddress.state_province,
      partner_id: sessionData.partnerId,
      product_type: 'car',
      platform: sessionData.platform != null && sessionData.platform == 'SOR' ? sessionData.platform : 'ICE',
    };
  }

  public recordEvent(eventName: any, context: any, data: any) {
    // for Tealium this is not implemented
  };

  public recordPageView(pageType: AnalyticsPageType, data: any) {
    console.log('TealiumHub was not executed');
    return;
  };

  public trackPageView(pageType: AnalyticsPageType, data: any) {
    // for Tealium this is not implemented
  };

  public recordException(exception: Error) {
    // for Tealium this is not implemented
  }
}
